import { render, staticRenderFns } from "./ModalReviewAssessment.vue?vue&type=template&id=21aa5a9a&"
import script from "./ModalReviewAssessment.vue?vue&type=script&lang=js&"
export * from "./ModalReviewAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports